import React from "react";

export default (props) => {
	return (<>
		{eval(props.element.formula)(...props.value)}
	</>);
};